const init = JSON.parse(localStorage.getItem('init'));
const product_metafields = init ? init.product_metafields.map(metafield => {
  return `{namespace: "${metafield.namespace}", key: "${metafield.key}"}`
}) : [];

export const cartCreateMutation = `mutation cartCreate($input: CartInput!) {
  cartCreate(input: $input) {
    cart {
      id
      checkoutUrl
      buyerIdentity {
        countryCode
        email
      }
      deliveryGroups (first: 100) {
          edges {
            node {
              id
              deliveryAddress {
                address1
                address2
                city
                company
                country
                countryCodeV2
                zip
              }
            }
          }
      }
      totalQuantity
      appliedGiftCards { 
        amountUsed {
          amount
          currencyCode
        }
        balance {
          amount
          currencyCode
        }
        id
        lastCharacters
      }
      attributes {
        key
        value
      }
      cost {
        subtotalAmount {
          amount
          currencyCode
        }
        totalAmount {
          amount
          currencyCode
        }        
        totalDutyAmount {
          amount
          currencyCode
        }
        totalTaxAmount {
          amount
          currencyCode
        }
        subtotalAmountEstimated
        totalAmountEstimated
        totalDutyAmountEstimated
        totalTaxAmountEstimated
        checkoutChargeAmount {
          amount
          currencyCode
        }
      }
      createdAt
      note
      totalQuantity
      updatedAt
      discountCodes {
        applicable
        code
      }
      discountAllocations {          
            ... on CartAutomaticDiscountAllocation {
              discountedAmount {
                  amount
                  currencyCode
              }
              targetType
              title
            }
            ... on CartCodeDiscountAllocation {
              code
              discountedAmount {
                amount
                currencyCode
              }
              targetType
            }
        }
      lines(first: 100) {
        edges {
          node {
            id
            attributes {
              key
              value
            }
            discountAllocations {          
              ... on CartAutomaticDiscountAllocation {
                discountedAmount {
                    amount
                    currencyCode
                }
                targetType
                title
              }
              ... on CartCodeDiscountAllocation {
                code
                discountedAmount {
                  amount
                  currencyCode
                }
                targetType
              }
            }
            cost {
              amountPerQuantity {
                amount
                currencyCode
              }
              totalAmount {
                amount
                currencyCode
              }
              subtotalAmount {
                amount
                currencyCode
              }
            }
            quantity
            sellingPlanAllocation {
              checkoutChargeAmount {
                amount
                currencyCode
              }
              sellingPlan {
                id
                description
                name                       
              }
            }
            merchandise {
              ... on ProductVariant {
                id
                availableForSale
                barcode
                product {
                  handle
                  vendor
                  productType
                  createdAt
                  availableForSale
                  description
                  id
                  tags
                  title
                  condition: metafield(namespace: "pdp", key: "condition") {
                    id
                    value
                  }
                  product_details: metafields(identifiers: [${product_metafields.join(', ')}]) {
                    key
                    value
                  }
                  featuredImage {
                    url
                    id
                    altText
                    height
                    width
                  }
                }
                image {
                  url
                  id
                  altText
                  height
                  width       
                }
                price {
                  amount
                  currencyCode
                }
                quantityAvailable
                sku
                title
                taxable
                unitPrice {
                  amount
                  currencyCode
                }
              }
            }
          }
        }
      }
    }
    userErrors {
      field
      message
    }
  }
}`;

export const cartDiscountsUpdateMutation = `mutation cartDiscountCodesUpdate($cartId: ID!, $discountCodes: [String!]!) {
  cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $discountCodes) {
    cart {
      id
      checkoutUrl
      buyerIdentity {
        countryCode
        email
      }
      deliveryGroups (first: 100) {
          edges {
            node {
              id
              deliveryAddress {
                address1
                address2
                city
                company
                country
                countryCodeV2
                zip
              }
            }
          }
      }
      totalQuantity
      appliedGiftCards { 
        amountUsed {
          amount
          currencyCode
        }
        balance {
          amount
          currencyCode
        }
        id
        lastCharacters
      }
      attributes {
        key
        value
      }
      cost {
        subtotalAmount {
          amount
          currencyCode
        }
        totalAmount {
          amount
          currencyCode
        }        
        totalDutyAmount {
          amount
          currencyCode
        }
        totalTaxAmount {
          amount
          currencyCode
        }
        subtotalAmountEstimated
        totalAmountEstimated
        totalDutyAmountEstimated
        totalTaxAmountEstimated
        checkoutChargeAmount {
          amount
          currencyCode
        }
      }
      createdAt
      note
      totalQuantity
      updatedAt
      discountCodes {
        applicable
        code
      }
      discountAllocations {          
        ... on CartAutomaticDiscountAllocation {
          discountedAmount {
              amount
              currencyCode
          }
          targetType
          title
        }
        ... on CartCodeDiscountAllocation {
          code
          discountedAmount {
            amount
            currencyCode
          }
          targetType
        }
      }
      lines(first: 100) {
        edges {
          node {
            id
            attributes {
              key
              value
            }
            discountAllocations {          
              ... on CartAutomaticDiscountAllocation {
                discountedAmount {
                    amount
                    currencyCode
                }
                targetType
                title
              }
              ... on CartCodeDiscountAllocation {
                code
                discountedAmount {
                  amount
                  currencyCode
                }
                targetType
              }
            }
            cost {
              amountPerQuantity {
                amount
                currencyCode
              }
              totalAmount {
                amount
                currencyCode
              }
              subtotalAmount {
                amount
                currencyCode
              }
            }
            quantity
            sellingPlanAllocation {
              checkoutChargeAmount {
                amount
                currencyCode
              }
              sellingPlan {
                id
                description
                name                       
              }
            }
            merchandise {
              ... on ProductVariant {
                id
                availableForSale
                barcode
                product {
                  product_details: metafields(identifiers: [${product_metafields.join(', ')}]) {
                      key
                      value
                  }
                  handle
                  vendor
                  productType
                  createdAt
                  availableForSale
                  description
                  id
                  tags
                  title
                  condition: metafield(namespace: "pdp", key: "condition") {
                    id
                    value
                  }
                  featuredImage {
                    url
                    id
                    altText
                    height
                    width
                  }
                }
                image {
                  url
                  id
                  altText
                  height
                  width       
                }
                price {
                  amount
                  currencyCode
                }
                quantityAvailable
                sku
                title
                taxable
                unitPrice {
                  amount
                  currencyCode
                }
              }
            }
          }
        }
      }
    }
    userErrors {
      field
      message
    }
  }
}`;

export const removeCartLineItemsMutation = `mutation cartLinesRemove($cartId: ID!, $lineIds: [ID!]!) {
  cartLinesRemove(cartId: $cartId, lineIds: $lineIds) {
    cart {
      id
      checkoutUrl
      buyerIdentity {
        countryCode
        email
      }
      deliveryGroups (first: 100) {
          edges {
            node {
              id
              deliveryAddress {
                address1
                address2
                city
                company
                country
                countryCodeV2
                zip
              }
            }
          }
      }
      totalQuantity
      appliedGiftCards { 
        amountUsed {
          amount
          currencyCode
        }
        balance {
          amount
          currencyCode
        }
        id
        lastCharacters
      }
      attributes {
        key
        value
      }
      cost {
        subtotalAmount {
          amount
          currencyCode
        }
        totalAmount {
          amount
          currencyCode
        }        
        totalDutyAmount {
          amount
          currencyCode
        }
        totalTaxAmount {
          amount
          currencyCode
        }
        subtotalAmountEstimated
        totalAmountEstimated
        totalDutyAmountEstimated
        totalTaxAmountEstimated
        checkoutChargeAmount {
          amount
          currencyCode
        }
      }
      createdAt
      note
      totalQuantity
      updatedAt
      discountCodes {
        applicable
        code
      }
      discountAllocations {          
        ... on CartAutomaticDiscountAllocation {
          discountedAmount {
              amount
              currencyCode
          }
          targetType
          title
        }
        ... on CartCodeDiscountAllocation {
          code
          discountedAmount {
            amount
            currencyCode
          }
          targetType
        }
      }
      lines(first: 100) {
        edges {
          node {
            id
            attributes {
              key
              value
            }
            discountAllocations {          
              ... on CartAutomaticDiscountAllocation {
                discountedAmount {
                    amount
                    currencyCode
                }
                targetType
                title
              }
              ... on CartCodeDiscountAllocation {
                code
                discountedAmount {
                  amount
                  currencyCode
                }
                targetType
              }
            }
            cost {
              amountPerQuantity {
                amount
                currencyCode
              }
              totalAmount {
                amount
                currencyCode
              }
              subtotalAmount {
                amount
                currencyCode
              }
            }
            quantity
            sellingPlanAllocation {
              checkoutChargeAmount {
                amount
                currencyCode
              }
              sellingPlan {
                id
                description
                name                       
              }
            }
            merchandise {
              ... on ProductVariant {
                id
                availableForSale
                barcode
                product {
                  product_details: metafields(identifiers: [${product_metafields.join(', ')}]) {
                    key
                    value
                  }
                  handle
                  vendor
                  productType
                  createdAt
                  availableForSale
                  description
                  id
                  tags
                  title
                  condition: metafield(namespace: "pdp", key: "condition") {
                    id
                    value
                  }
                  featuredImage {
                    url
                    id
                    altText
                    height
                    width
                  }
                }
                image {
                  url
                  id
                  altText
                  height
                  width       
                }
                price {
                  amount
                  currencyCode
                }
                quantityAvailable
                sku
                title
                taxable
                unitPrice {
                  amount
                  currencyCode
                }
              }
            }
          }
        }
      }
    }
    userErrors {
      field
      message
    }
  }
}`

export const addCartLineItemsMutation = `mutation cartLinesAdd($cartId: ID!, $lines: [CartLineInput!]!) {
  cartLinesAdd(cartId: $cartId, lines: $lines) {
    cart {
      id
      checkoutUrl
      buyerIdentity {
        countryCode
        email
      }
      deliveryGroups (first: 100) {
          edges {
            node {
              id
              deliveryAddress {
                address1
                address2
                city
                company
                country
                countryCodeV2
                zip
              }
            }
          }
      }
      totalQuantity
      appliedGiftCards { 
        amountUsed {
          amount
          currencyCode
        }
        balance {
          amount
          currencyCode
        }
        id
        lastCharacters
      }
      attributes {
        key
        value
      }
      cost {
        subtotalAmount {
          amount
          currencyCode
        }
        totalAmount {
          amount
          currencyCode
        }        
        totalDutyAmount {
          amount
          currencyCode
        }
        totalTaxAmount {
          amount
          currencyCode
        }
        subtotalAmountEstimated
        totalAmountEstimated
        totalDutyAmountEstimated
        totalTaxAmountEstimated
        checkoutChargeAmount {
          amount
          currencyCode
        }
      }
      createdAt
      note
      totalQuantity
      updatedAt
      discountCodes {
        applicable
        code
      }
      discountAllocations {          
        ... on CartAutomaticDiscountAllocation {
          discountedAmount {
              amount
              currencyCode
          }
          targetType
          title
        }
        ... on CartCodeDiscountAllocation {
          code
          discountedAmount {
            amount
            currencyCode
          }
          targetType
        }
      }
      lines(first: 100) {
        edges {
          node {
            id
            attributes {
              key
              value
            }
            discountAllocations {          
              ... on CartAutomaticDiscountAllocation {
                discountedAmount {
                    amount
                    currencyCode
                }
                targetType
                title
              }
              ... on CartCodeDiscountAllocation {
                code
                discountedAmount {
                  amount
                  currencyCode
                }
                targetType
              }
            }
            cost {
              amountPerQuantity {
                amount
                currencyCode
              }
              totalAmount {
                amount
                currencyCode
              }
              subtotalAmount {
                amount
                currencyCode
              }
            }
            quantity
            sellingPlanAllocation {
              checkoutChargeAmount {
                amount
                currencyCode
              }
              sellingPlan {
                id
                description
                name                       
              }
            }
            merchandise {
              ... on ProductVariant {
                id
                availableForSale
                barcode
                product {
                  product_details: metafields(identifiers: [${product_metafields.join(', ')}]) {
                    key
                    value
                  }
                  handle
                  vendor
                  productType
                  createdAt
                  availableForSale
                  description
                  id
                  tags
                  title
                  condition: metafield(namespace: "pdp", key: "condition") {
                    id
                    value
                  }
                  featuredImage {
                    url
                    id
                    altText
                    height
                    width
                  }
                }
                image {
                  url
                  id
                  altText
                  height
                  width       
                }
                price {
                  amount
                  currencyCode
                }
                quantityAvailable
                sku
                title
                taxable
                unitPrice {
                  amount
                  currencyCode
                }
              }
            }
          }
        }
      }
    }
    userErrors {
      field
      message
    }
  }
}`

export const updateCartLineItemsMutation = `mutation cartLinesUpdate($cartId: ID!, $lines: [CartLineUpdateInput!]!) {
  cartLinesUpdate(cartId: $cartId, lines: $lines) {
    cart {
      id
      checkoutUrl
      buyerIdentity {
        countryCode
        email
      }
      deliveryGroups (first: 100) {
          edges {
            node {
              id
              deliveryAddress {
                address1
                address2
                city
                company
                country
                countryCodeV2
                zip
              }
            }
          }
      }
      totalQuantity
      appliedGiftCards { 
        amountUsed {
          amount
          currencyCode
        }
        balance {
          amount
          currencyCode
        }
        id
        lastCharacters
      }
      attributes {
        key
        value
      }
      cost {
        subtotalAmount {
          amount
          currencyCode
        }
        totalAmount {
          amount
          currencyCode
        }        
        totalDutyAmount {
          amount
          currencyCode
        }
        totalTaxAmount {
          amount
          currencyCode
        }
        subtotalAmountEstimated
        totalAmountEstimated
        totalDutyAmountEstimated
        totalTaxAmountEstimated
        checkoutChargeAmount {
          amount
          currencyCode
        }
      }
      createdAt
      note
      totalQuantity
      updatedAt
      discountCodes {
        applicable
        code
      }
      discountAllocations {          
        ... on CartAutomaticDiscountAllocation {
          discountedAmount {
              amount
              currencyCode
          }
          targetType
          title
        }
        ... on CartCodeDiscountAllocation {
          code
          discountedAmount {
            amount
            currencyCode
          }
          targetType
        }
      }
      lines(first: 100) {
        edges {
          node {
            id
            attributes {
              key
              value
            }
            discountAllocations {          
              ... on CartAutomaticDiscountAllocation {
                discountedAmount {
                    amount
                    currencyCode
                }
                targetType
                title
              }
              ... on CartCodeDiscountAllocation {
                code
                discountedAmount {
                  amount
                  currencyCode
                }
                targetType
              }
            }
            cost {
              amountPerQuantity {
                amount
                currencyCode
              }
              totalAmount {
                amount
                currencyCode
              }
              subtotalAmount {
                amount
                currencyCode
              }
            }
            quantity
            sellingPlanAllocation {
              checkoutChargeAmount {
                amount
                currencyCode
              }
              sellingPlan {
                id
                description
                name                       
              }
            }
            merchandise {
              ... on ProductVariant {
                id
                availableForSale
                barcode
                product {
                  product_details: metafields(identifiers: [${product_metafields.join(', ')}]) {
                    key
                    value
                  }
                  handle
                  vendor
                  productType
                  createdAt
                  availableForSale
                  description
                  id
                  tags
                  title
                  condition: metafield(namespace: "pdp", key: "condition") {
                    id
                    value
                  }
                  featuredImage {
                    url
                    id
                    altText
                    height
                    width
                  }
                }
                image {
                  url
                  id
                  altText
                  height
                  width       
                }
                price {
                  amount
                  currencyCode
                }
                quantityAvailable
                sku
                title
                taxable
                unitPrice {
                  amount
                  currencyCode
                }
              }
            }
          }
        }
      }
    }
    userErrors {
      field
      message
    }
  }
}`

export const getCartQuery = `query cart($cartId: ID!) {
      cart(id: $cartId) {
        id
        buyerIdentity {
          countryCode
          email
        }
        deliveryGroups (first: 100) {
          edges {
            node {
              id
              deliveryAddress {
                address1
                address2
                city
                company
                country
                countryCodeV2
                zip
              }
            }
          }
        }
        checkoutUrl
        totalQuantity
        appliedGiftCards { 
          amountUsed {
            amount
            currencyCode
          }
          balance {
            amount
            currencyCode
          }
          id
          lastCharacters
        }
        attributes {
          key
          value
        }
        cost {
          subtotalAmount {
            amount
            currencyCode
          }
          totalAmount {
            amount
            currencyCode
          }        
          totalDutyAmount {
            amount
            currencyCode
          }
          totalTaxAmount {
            amount
            currencyCode
          }
          subtotalAmountEstimated
          totalAmountEstimated
          totalDutyAmountEstimated
          totalTaxAmountEstimated
          checkoutChargeAmount {
            amount
            currencyCode
          }
        }
        createdAt
        note
        totalQuantity
        updatedAt
        discountCodes {
            applicable
            code
        }
        discountAllocations {          
          ... on CartAutomaticDiscountAllocation {
            discountedAmount {
                amount
                currencyCode
            }
            targetType
            title
          }
          ... on CartCodeDiscountAllocation {
            code
            discountedAmount {
              amount
              currencyCode
            }
            targetType
          }
        }
        lines (first:100) {
            edges {
                node {
                    id
                    attributes {
                      key
                      value
                    }
                    discountAllocations {          
                      ... on CartAutomaticDiscountAllocation {
                        discountedAmount {
                            amount
                            currencyCode
                        }
                        targetType
                        title
                      }
                      ... on CartCodeDiscountAllocation {
                        code
                        discountedAmount {
                          amount
                          currencyCode
                        }
                        targetType
                      }
                    }
                    cost {
                      amountPerQuantity {
                        amount
                        currencyCode
                      }
                      totalAmount {
                        amount
                        currencyCode
                      }
                      subtotalAmount {
                        amount
                        currencyCode
                      }
                    }
                    quantity
                    sellingPlanAllocation {
                      checkoutChargeAmount {
                          amount
                          currencyCode
                      }
                      sellingPlan {
                          id
                          description
                          name                       
                      }
                    }
                    merchandise {
                        ... on ProductVariant {
                            id
                            availableForSale
                            barcode                        
                            product {
                              product_details: metafields(identifiers: [${product_metafields.join(', ')}]) {
                                key
                                value
                              }
                              handle
                              vendor
                              productType
                              createdAt
                              availableForSale
                              description
                              id
                              tags
                              title
                              condition: metafield(namespace: "pdp", key: "condition") {
                                id
                                value
                              }
                              featuredImage {
                                url
                                id
                                altText
                                height
                                width
                              }
                            }
                            image {
                                url
                                id
                                altText
                                height
                                width       
                            }
                            price {
                                amount
                                currencyCode
                            }
                            quantityAvailable
                            sku
                            title
                            taxable
                            unitPrice {
                              amount
                              currencyCode
                            }
                        }
                    }
                }
            }
        }
    }
}`

export const updateCheckoutAttributesMutation = `mutation checkoutAttributesUpdateV2($checkoutId: ID!, $input: CheckoutAttributesUpdateV2Input!) {
  checkoutAttributesUpdateV2(checkoutId: $checkoutId, input: $input) {
    checkout {
      id
      webUrl
      note
      customAttributes {
        key
        value
      }
    }
    checkoutUserErrors {
      code
      field
      message
    }
    userErrors {
      field
      message
    }
  }
}`

export const updateCartNoteMutation = `mutation cartNoteUpdate($cartId: ID!, $note: String!) {
  cartNoteUpdate(cartId: $cartId, note: $note) {
    cart {
      id
      note
      checkoutUrl
      buyerIdentity {
        countryCode
        email
      }
    }
    userErrors {
      field
      message
    }
  }
}`

export const updateCartAttributesMutation = `mutation cartAttributesUpdate($attributes: [AttributeInput!]!, $cartId: ID!) {
  cartAttributesUpdate(attributes: $attributes, cartId: $cartId) {
    cart {
      id
      buyerIdentity {
        countryCode
        email
      }
      deliveryGroups (first: 100) {
        edges {
          node {
            id
            deliveryAddress {
              address1
              address2
              city
              company
              country
              countryCodeV2
              zip
            }
          }
        }
      }
      checkoutUrl
      totalQuantity
      appliedGiftCards { 
        amountUsed {
          amount
          currencyCode
        }
        balance {
          amount
          currencyCode
        }
        id
        lastCharacters
      }
      attributes {
        key
        value
      }
      cost {
        subtotalAmount {
          amount
          currencyCode
        }
        totalAmount {
          amount
          currencyCode
        }        
        totalDutyAmount {
          amount
          currencyCode
        }
        totalTaxAmount {
          amount
          currencyCode
        }
        subtotalAmountEstimated
        totalAmountEstimated
        totalDutyAmountEstimated
        totalTaxAmountEstimated
        checkoutChargeAmount {
          amount
          currencyCode
        }
      }
      createdAt
      note
      totalQuantity
      updatedAt
      discountCodes {
          applicable
          code
      }
      discountAllocations {          
          ... on CartAutomaticDiscountAllocation {
            discountedAmount {
                amount
                currencyCode
            }
            targetType
            title
          }
          ... on CartCodeDiscountAllocation {
            code
            discountedAmount {
              amount
              currencyCode
            }
            targetType
          }
      }
      lines (first:100) {
          edges {
              node {
                  id
                  attributes {
                    key
                    value
                  }
                  cost {
                    amountPerQuantity {
                      amount
                      currencyCode
                    }
                    totalAmount {
                      amount
                      currencyCode
                    }
                    subtotalAmount {
                      amount
                      currencyCode
                    }
                  }
                  discountAllocations {
                    ... on CartAutomaticDiscountAllocation {
                      discountedAmount {
                          amount
                          currencyCode
                      }
                      targetType
                      title
                    }
                    ... on CartCodeDiscountAllocation {
                      code
                      discountedAmount {
                        amount
                        currencyCode
                      }
                      targetType
                    }
                  }
                  quantity
                  sellingPlanAllocation {
                    checkoutChargeAmount {
                        amount
                        currencyCode
                    }
                    sellingPlan {
                        id
                        description
                        name                       
                    }
                  }
                  merchandise {
                      ... on ProductVariant {
                          id
                          availableForSale
                          barcode                        
                          product {
                            product_details: metafields(identifiers: [${product_metafields.join(', ')}]) {
                              key
                              value
                            }
                            handle
                            vendor
                            productType
                            createdAt
                            availableForSale
                            description
                            id
                            tags
                            title
                            condition: metafield(namespace: "pdp", key: "condition") {
                              id
                              value
                            }
                            featuredImage {
                              url
                              id
                              altText
                              height
                              width
                            }
                          }
                          image {
                              url
                              id
                              altText
                              height
                              width       
                          }
                          price {
                              amount
                              currencyCode
                          }
                          quantityAvailable
                          sku
                          title
                          taxable
                          unitPrice {
                            amount
                            currencyCode
                          }
                      }
                  }
              }
          }
      }
    }
    userErrors {
      field
      message
    }
  }
}`

export const cartGiftCardsMutation = `mutation cartGiftCardCodesUpdate($cartId: ID!, $giftCardCodes: [String!]!) {
  cartGiftCardCodesUpdate(cartId: $cartId, giftCardCodes: $giftCardCodes) {
    cart {
      id
      buyerIdentity {
        countryCode
        email
      }
      deliveryGroups(first: 100) {
        edges {
          node {
            id
            deliveryAddress {
              address1
              address2
              city
              company
              country
              countryCodeV2
              zip
            }
          }
        }
      }
      checkoutUrl
      totalQuantity
      appliedGiftCards { 
        amountUsed {
          amount
          currencyCode
        }
        balance {
          amount
          currencyCode
        }
        id
        lastCharacters
      }
      attributes {
        key
        value
      }
      cost {
        subtotalAmount {
          amount
          currencyCode
        }
        totalAmount {
          amount
          currencyCode
        }        
        totalDutyAmount {
          amount
          currencyCode
        }
        totalTaxAmount {
          amount
          currencyCode
        }
        subtotalAmountEstimated
        totalAmountEstimated
        totalDutyAmountEstimated
        totalTaxAmountEstimated
        checkoutChargeAmount {
          amount
          currencyCode
        }
      }
      createdAt
      note
      totalQuantity
      updatedAt
      discountCodes {
        applicable
        code
      }
      discountAllocations {          
        ... on CartAutomaticDiscountAllocation {
          discountedAmount {
            amount
            currencyCode
          }
          targetType
          title
        }
        ... on CartCodeDiscountAllocation {
          code
          discountedAmount {
            amount
            currencyCode
          }
          targetType
        }
      }
      lines(first: 100) {
        edges {
          node {
            id
            attributes {
              key
              value
            }
            cost {
              amountPerQuantity {
                amount
                currencyCode
              }
              totalAmount {
                amount
                currencyCode
              }
              subtotalAmount {
                amount
                currencyCode
              }
            }
            discountAllocations {
              ... on CartAutomaticDiscountAllocation {
                discountedAmount {
                  amount
                  currencyCode
                }
                targetType
                title
              }
              ... on CartCodeDiscountAllocation {
                code
                discountedAmount {
                  amount
                  currencyCode
                }
                targetType
              }
            }
            quantity
            sellingPlanAllocation {
              checkoutChargeAmount {
                amount
                currencyCode
              }
              sellingPlan {
                id
                description
                name                       
              }
            }
            merchandise {
              ... on ProductVariant {
                id
                availableForSale
                barcode                        
                product {
                  product_details: metafields(identifiers: [${product_metafields.join(', ')}]) {
                    key
                    value
                  }
                  handle
                  vendor
                  productType
                  createdAt
                  availableForSale
                  description
                  id
                  tags
                  title
                  condition: metafield(namespace: "pdp", key: "condition") {
                    id
                    value
                  }
                  featuredImage {
                    url
                    id
                    altText
                    height
                    width
                  }
                }
                image {
                  url
                  id
                  altText
                  height
                  width       
                }
                price {
                  amount
                  currencyCode
                }
                quantityAvailable
                sku
                title
                taxable
                unitPrice {
                  amount
                  currencyCode
                }
              }
            }
          }
        }
      }
    }
    userErrors {
      field
      message
    }
  }
}
`

export const cartBuyerIdentityMutation = `mutation cartBuyerIdentityUpdate($buyerIdentity: CartBuyerIdentityInput!, $cartId: ID!) {
  cartBuyerIdentityUpdate(buyerIdentity: $buyerIdentity, cartId: $cartId) {
    cart {
      id
      buyerIdentity {
        countryCode
        email
      }
      deliveryGroups (first: 100) {
        edges {
          node {
            id
            deliveryAddress {
              address1
              address2
              city
              company
              country
              countryCodeV2
              zip
            }
          }
        }
      }
      checkoutUrl
      totalQuantity
      appliedGiftCards { 
        amountUsed {
          amount
          currencyCode
        }
        balance {
          amount
          currencyCode
        }
        id
        lastCharacters
      }
      attributes {
        key
        value
      }
      cost {
        subtotalAmount {
          amount
          currencyCode
        }
        totalAmount {
          amount
          currencyCode
        }        
        totalDutyAmount {
          amount
          currencyCode
        }
        totalTaxAmount {
          amount
          currencyCode
        }
        subtotalAmountEstimated
        totalAmountEstimated
        totalDutyAmountEstimated
        totalTaxAmountEstimated
        checkoutChargeAmount {
          amount
          currencyCode
        }
      }
      createdAt
      note
      totalQuantity
      updatedAt
      discountCodes {
          applicable
          code
      }
      discountAllocations {          
          ... on CartAutomaticDiscountAllocation {
            discountedAmount {
                amount
                currencyCode
            }
            targetType
            title
          }
          ... on CartCodeDiscountAllocation {
            code
            discountedAmount {
              amount
              currencyCode
            }
            targetType
          }
      }
      lines (first:100) {
          edges {
              node {
                  id
                  attributes {
                    key
                    value
                  }
                  cost {
                    amountPerQuantity {
                      amount
                      currencyCode
                    }
                    totalAmount {
                      amount
                      currencyCode
                    }
                    subtotalAmount {
                      amount
                      currencyCode
                    }
                  }
                  discountAllocations {
                    ... on CartAutomaticDiscountAllocation {
                      discountedAmount {
                          amount
                          currencyCode
                      }
                      targetType
                      title
                    }
                    ... on CartCodeDiscountAllocation {
                      code
                      discountedAmount {
                        amount
                        currencyCode
                      }
                      targetType
                    }
                  }
                  quantity
                  sellingPlanAllocation {
                    checkoutChargeAmount {
                        amount
                        currencyCode
                    }
                    sellingPlan {
                        id
                        description
                        name                       
                    }
                  }
                  merchandise {
                      ... on ProductVariant {
                          id
                          availableForSale
                          barcode                        
                          product {
                            product_details: metafields(identifiers: [${product_metafields.join(', ')}]) {
                              key
                              value
                            }
                            handle
                            vendor
                            productType
                            createdAt
                            availableForSale
                            description
                            id
                            tags
                            title
                            condition: metafield(namespace: "pdp", key: "condition") {
                              id
                              value
                            }
                            featuredImage {
                              url
                              id
                              altText
                              height
                              width
                            }
                          }
                          image {
                              url
                              id
                              altText
                              height
                              width       
                          }
                          price {
                              amount
                              currencyCode
                          }
                          quantityAvailable
                          sku
                          title
                          taxable
                          unitPrice {
                            amount
                            currencyCode
                          }
                      }
                  }
              }
          }
      }
    }
    userErrors {
      field
      message
    }
  }
}`